<template>
  <v-menu
    v-if="hasAnyItemsInMenu"
    v-model="showingMenu"
    v-bind:close-on-content-click="false"
    location="bottom"
    eager
  >
    <template v-slot:activator="{ props }">
      <slot name="activator" v-bind="{ props }"/>
    </template>

    <v-list data-cy="pods-download--list">
      <v-list-item @click="downloadOriginal">
        <template v-slot:prepend>
          <v-icon size="small">mdi-download</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.downloadOriginal') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item v-if="isImagePod" @click="showConvertImageFileDialog">
        <template v-slot:prepend>
          <v-icon size="small">mdi-download</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.downloadAs') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="downloadPreview" :disabled="!getPreviewURL">
        <template v-slot:prepend>
          <v-icon size="small">mdi-monitor-arrow-down</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.downloadPreview') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="downloadAllAssets">
        <template v-slot:prepend>
          <v-icon size="small">mdi-folder-download</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.downloadAssets') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="downloadNote">
        <template v-slot:prepend>
          <v-icon size="small">mdi-note-text-outline</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.downloadNote') }}
        </v-list-item-title>
      </v-list-item>

      <v-divider v-if="$canDownloadNodeAndPod() && $canBelongstoTeam()" aria-hidden="true" />

      <v-list-item
        v-if="$canDownloadNodeAndPod() && $canBelongstoTeam()"
        @click="showExportPodDialog"
        data-cy="pod-file-list-exportPod"
      >
        <template v-slot:prepend>
          <v-icon size="small">mdi-application-export</v-icon>
        </template>

        <v-list-item-title>
          {{ $t('routes.pod.exportFile') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <DownloadImageAsDialog
    v-if="isImagePod"
    v-model="showingConvertImageFileDialog"
    :pod="pod"
  />

  <ExportPodDialog v-if="$canDownloadNodeAndPod()" v-model="showingExportPodDialog" :pods="[pod]"/>

</template>

<script>
import { usePodStore } from '@/stores/PodStore.js';
import { useAuthStore } from '@/stores/AuthStore.js';
import { useCommonStore } from '@/stores/CommonStore.js';
import Api from '@/api/Api';
import DownloadImageAsDialog from '@/routes/pods2/components/dialogs/DownloadImageAsDialog.vue';
import ExportPodDialog from "../dialogs/ExportPodDialog.vue"

export default {
  name: "DownloadContextMenu",
  components: {
    DownloadImageAsDialog,
    ExportPodDialog,
  },
  data() {
    return {
      showingMenu: false,
      showingConvertImageFileDialog: false,
      showingExportPodDialog: false,
    }
  },
  methods: {
    stub: function() {
      this.showingMenu = false;
    },
    async downloadOriginal() {
      if (this.pod &&
          this.pod.asset &&
          this.pod.asset.raw &&
          this.pod.asset.raw[0] &&
          this.pod.asset.raw[0].url)
      {
        try {
          const rawAsset = this.pod.asset.raw[0];
          const response = await Api.pod.issueRawAssetDownloadUrl(this.pod.id, rawAsset.id);

          if (response?.data?.url) {
            window.location = response.data.url;
          }
        } catch (error) {
          const message = error?.response?.error
            ? this.$localizeMessage(error.response.error, this.$t('backend.system-error'))
            : this.$t('backend.system-error');
          this.$showMessage(message, { type: 'error' });
        }
      }
    },
    downloadPreview() {
      if (this.getPreviewURL) {
        window.location = this.getPreviewURL;
      }
    },
    downloadAllAssets() {
      let payload = {
        nodeids: [],
        podids: [this.pod.id],
        assetids: [],
        excludeAssets: false,
      };

      const authStore = useAuthStore();
      authStore.getCurrentSession()
        .then(function(session) {
          payload['id-token'] = session.tokens.idToken.toString();
          const commonStore = useCommonStore();
          return commonStore.downloadThings(payload);
        });
    },
    downloadNote() {
      const commonStore = useCommonStore();

      this.showingMenu = false;
      commonStore.downloadMediaNotes({
        nodeids: [],
        podids: [this.pod.id],
      });
    },
    showConvertImageFileDialog: function() {
      this.showingConvertImageFileDialog = true;
      this.showingMenu = false;
    },
    showExportPodDialog: function() {
      this.showingExportPodDialog = true;
      this.showingMenu = false;
    },
  },
  computed: {
    hasAnyItemsInMenu: function() {
      // return this.$canControlNodeAndPod() ||
      //         this.$canDownloadNodeAndPod();
      return this.$canDownloadNodeAndPod() && this.pod ? true : false;  // TODO: Probably check this out at some point
    },
    pod: function() {
      const podStore = usePodStore();
      return podStore.getViewPod;
    },
    isVideoPod: function() {
      const podStore = usePodStore();
      return podStore.isVideoPod;
    },
    isImagePod: function() {
      const podStore = usePodStore();
      return podStore.isImagePod;
    },
    isAudioPod: function() {
      const podStore = usePodStore();
      return podStore.isAudioPod;
    },
    getPreviewURL() {
      let assetType = '';
      if (this.isVideoPod) assetType = 'web';
      if (this.isAudioPod) assetType = 'web';
      if (this.isImagePod) assetType = 'thumbnail';

      if (assetType &&
          this.pod &&
          this.pod.asset &&
          this.pod.asset[assetType] &&
          this.pod.asset[assetType][0] &&
          this.pod.asset[assetType][0].url)
      {
        return this.pod.asset[assetType][0].url;
      }

      return '';
    }
  }
}
</script>

<style>
</style>
